// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-input-container {
  width: var(--color-input-width);
  height: var(--input-element-height);
  border: 1px solid var(--border-color);
  border-radius: calc(var(--input-element-height) / 2);
  box-sizing: border-box;
  position: relative;
  font-size: var(--font-size-l);
  cursor: pointer;
}

.color-input-container-disabled {
  cursor: default !important;
}

.color-input-container input[type="color"] {
  width: var(--color-input-width);
  opacity: 0;
  cursor: inherit;
}

.color-input-container svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/color-input/ColorInput.component.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,qCAAqC;EACrC,oDAAoD;EACpD,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB","sourcesContent":[".color-input-container {\n  width: var(--color-input-width);\n  height: var(--input-element-height);\n  border: 1px solid var(--border-color);\n  border-radius: calc(var(--input-element-height) / 2);\n  box-sizing: border-box;\n  position: relative;\n  font-size: var(--font-size-l);\n  cursor: pointer;\n}\n\n.color-input-container-disabled {\n  cursor: default !important;\n}\n\n.color-input-container input[type=\"color\"] {\n  width: var(--color-input-width);\n  opacity: 0;\n  cursor: inherit;\n}\n\n.color-input-container svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
